import { Component, TemplateRef, viewChild } from '@angular/core';

import { TooltipDirective, TooltipModule } from 'ngx-bootstrap/tooltip';

import { SelectIndicator } from '@bn/primitives';

@Component({
  selector: 'bn-web-ui-indicator-select-template',
  templateUrl: './indicator-select-template.component.html',
  styleUrls: ['./indicator-select-template.component.scss'],
  imports: [TooltipModule],
  providers: [TooltipDirective],
})
export class IndicatorSelectTemplateComponent {
  readonly indicatorTemplate = viewChild.required<TemplateRef<{ $implicit: SelectIndicator | undefined }>>('indicatorTemplate');
}
